import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ISearchCriteria, ISearchResponse } from './account-search.model';
import { IntegrationService } from '../../services/integration.service';
import { headerConstants, accountSearchConstants, queryParamConstants } from '../../constants';
import { AppSettingsService } from '@charlesschwab/as-ui-core';

@Injectable({
  providedIn: 'root'
})
class AccountSearchService {
  constructor(
    private http: HttpClient,
    private integrationService: IntegrationService,
    private settingsService: AppSettingsService
  ) {}

  search(criteria: ISearchCriteria): Observable<any> {
    const url =
      `${this.settingsService.settings.bffGatewayUrl}/api/ria.SacAipExperience/v1/AccountSearch` +
      '?' +
      accountSearchConstants.searchTermQueryKey +
      '=' +
      queryParamConstants.secureClientIdKeyOne +
      '&' +
      accountSearchConstants.isMasterQueryKey +
      '=' +
      criteria.isMaster;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        [headerConstants.sacContextKey]: this.integrationService.getContext(),
        [headerConstants.sacSessionIdKey]: this.integrationService.getSessionId(),
        [headerConstants.schwabClientIdsKey]: [queryParamConstants.secureClientIdKeyOne] + '=' + criteria.searchTerm
      })
    };

    return this.http
      .get<ISearchResponse>(url, httpOptions)
      .pipe(map((response: ISearchResponse) => response))
      .pipe(
        catchError((error) => {
          console.log('Error retieving search data ', error);
          return new Observable((s) => s.error('Data is not available at this time.'));
        })
      );
  }
}

export { AccountSearchService };
